import BaseApi from "./baseApi";

export default class OldProductsApi extends BaseApi {
    async getProducts(searchQuery: string): Promise<OldProduct[]> {
        const url = `/api/oldpricelist/search/${searchQuery}`;
        return await this.fetchGet(url);
    }
}
